import type { DatePickerMode } from '../types';

// Default date formats for different modes. Typed with explicit keys (via
// `satisfies`) so `DEFAULT_DATE_FORMATS.single` is a known, non-optional
// property — callers can use it as a fallback without a non-null assertion.
export const DEFAULT_DATE_FORMATS = {
  single: 'MM/dd/yyyy',
  range: 'MM/dd/yyyy',
  time: 'hh:mm a',
  'single-time': 'MM/dd/yyyy hh:mm a',
} satisfies Record<DatePickerMode, string>;

// Default minimum and maximum dates
export const DEFAULT_MIN_DATE = new Date('0001-01-01');
export const DEFAULT_MAX_DATE = new Date(
  new Date().setFullYear(new Date().getFullYear() + 100),
);
